"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMasteryDetailByClass = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var responsive_helper_1 = require("../../../api/helpers/responsive.helper");
exports.StyledMasteryDetailByClass = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .card {\n    height: 12rem;\n    ", "\n\n    .card-header {\n      padding: ", ";\n    }\n\n    .stacked-bar {\n      margin: ", ";\n    }\n\n    .legend-container {\n      ", ";\n      flex-wrap: wrap;\n      margin-top: ", ";\n      margin-left: ", ";\n\n      > div {\n        width: 150px;\n        margin-right: ", ";\n      }\n    }\n  }\n"], ["\n  .card {\n    height: 12rem;\n    ", "\n\n    .card-header {\n      padding: ", ";\n    }\n\n    .stacked-bar {\n      margin: ", ";\n    }\n\n    .legend-container {\n      ", ";\n      flex-wrap: wrap;\n      margin-top: ", ";\n      margin-left: ", ";\n\n      > div {\n        width: 150px;\n        margin-right: ", ";\n      }\n    }\n  }\n"])), (0, responsive_helper_1.mediaMinWidth)('lg')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 16rem;\n    "], ["\n      height: 16rem;\n    "]))), function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x4, " 0 ").concat(Spacing.x4, " ").concat(Spacing.x4);
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "0 ".concat(Spacing.x3, " ").concat(Spacing.x4, " ").concat(Spacing.x4);
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
});
var templateObject_1, templateObject_2;
